"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ProgressDonut = require("./ProgressDonut");
Object.keys(_ProgressDonut).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProgressDonut[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProgressDonut[key];
    }
  });
});